// Modules
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
// Components
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class InfoFieldSelectorModalModule {
}
InfoFieldSelectorModalModule.ɵfac = function InfoFieldSelectorModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InfoFieldSelectorModalModule)(); };
InfoFieldSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: InfoFieldSelectorModalModule });
InfoFieldSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule,
        CommonModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        FeatureNeededModule] });
